import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { useActionPermission } from "@/modules/auth/presentation/model/useActionPermission";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { Button } from "@devhop/ui";
import { useNavigate } from "@tanstack/react-router";
import { PlusIcon } from "lucide-react";
import { useSocialSalesSourcesListQuery } from "../api/queries";
import { SocialSalesSourcesTable } from "../ui/SocialSalesSourcesTable";

export function SocialSalesSourcesPage() {
  const nav = useNavigate({ from: "/app/settings/social-sales-sources" });
  const list = useSocialSalesSourcesListQuery(false);
  const rows = list.data ?? [];
  const canCreate = useActionPermission(["social_sources:create"]);
  const canEditRows = useActionPermission(["social_sources:update"]);

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ແຫຼ່ງຂາຍ Social Media" },
          ]}
        />
      </Header>
      <Main>
        <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
          <div>
            <h2 className="font-bold text-2xl tracking-tight">
              ແຫຼ່ງຂາຍ Social Media
            </h2>
            <p className="text-muted-foreground text-sm">
              ຈັດການລາຍການທີ່ POS ເລືອກເມື່ອຊ່ອງທາງເປັນ Social Media
            </p>
          </div>
          {canCreate ? (
            <Button
              onClick={() =>
                nav({ to: "/app/settings/social-sales-sources/new" })
              }
            >
              <PlusIcon className="size-4" />
              ເພີ່ມແຫຼ່ງ
            </Button>
          ) : null}
        </div>
        <div className="flex flex-col rounded-xl border bg-card pt-2">
          <SocialSalesSourcesTable
            canEditRows={!!canEditRows}
            data={rows}
            isLoading={list.isLoading}
            onEdit={(row) =>
              nav({
                to: "/app/settings/social-sales-sources/$id/edit",
                params: { id: row.id },
              })
            }
          />
        </div>
      </Main>
    </>
  );
}
